import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { MetaEventAudit } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/meta-events")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <MetaEventAudit />
    </RouteGuard>
  ),
});
